export const VARIABLE_EXCEPTION_COMPONENTS = ['TEXTINPUT', 'SELECT', 'CHECKBOX', 'RADIO_BUTTON', 'FILEUPLOAD', 'SLIDER', 'TOGGLE_SWITCH', 'TEXTAREA', 'SIGNATURE', 'ADDRESS_BOOK', 'BARCODE_SCANNER', 'GPS', 'PHONE_CALL', 'AUTOCOMPLETE', 'STEPPER'];
export const DEFAULT_ICON_POSITION = "left";

